<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Cast of Characters</h1>
</div>
</div>
<table style="font-size: 1em; line-height: 1.375; width: 100%;">
<tbody>
<tr>
<td style="width: 35%;" valign="top">
				Alexand DeKoven Woolf<br/>
				(Alex Ransom)</td>
<td valign="top">
				First born and heir to the First Lordship of the House of DeKoven Woolf, indirect heir to the Chairmanship of the Directorate</td>
</tr>
<tr>
<td valign="top">
				Richard DeKoven Woolf<br/>
				(Richard Lamb)</td>
<td valign="top">
				Alexand’s younger brother</td>
</tr>
<tr>
<td valign="top">
				Phillip DeKoven Woolf</td>
<td valign="top">
				Alexand’s father, First Lord of the House of DeKovep Woolf and member of the Directorate</td>
</tr>
<tr>
<td valign="top">
				Elise Galinin Woolf</td>
<td valign="top">
				Alexand’s mother, the daughter of Mathis Galinin</td>
</tr>
<tr>
<td valign="top">
				Theron Rovere</td>
<td valign="top">
				Lector; Alexand’s and Rich’s tutor</td>
</tr>
<tr>
<td valign="top">
				Fenn Lacroy</td>
<td valign="top">
				SportsMaster in the House of DeKoven Woolf and Phoenix agent</td>
</tr>
<tr>
<td valign="top">
				Mathis Daro Galinin</td>
<td valign="top">
				First Lord of the House of Daro Galinin and Chairman of the Directorate</td>
</tr>
<tr>
<td valign="top">
				Orin Badir Selasis</td>
<td valign="top">
				First Lord of the House of Badir Selasis, member of the Directorate, and bitter antagonist to Woolf and Galinin</td>
</tr>
<tr>
<td valign="top">
				Karlis Selasis</td>
<td valign="top">
				First born of Lord Orin Selasis</td>
</tr>
<tr>
<td valign="top">
				Adrien Camine Eliseer</td>
<td valign="top">
				Daughter of Lord Loren Camine Eliseer of Castor, and Alexand’s Promised</td>
</tr>
<tr>
<td valign="top">
				Lectris and Mariet</td>
<td valign="top">
				Adrien’s Bond servants</td>
</tr>
<tr>
<td valign="top">
				Amik the Thief</td>
<td valign="top">
				Also known as the Lord of Thieves, head of the Brotherhood, a predominantly criminal organization prevalent in the Outside</td>
</tr>
<tr>
<td valign="top">
				Master Bruno<br/>
				Hawkwood</td>
<td valign="top">
				Orin Selasis’s chief henchman, also known as the Master of Shadows</td>
</tr>
<tr>
<td valign="top">
				Dr. Lile Perralt</td>
<td valign="top">
				Eliseer family physician and a Phoenix agent</td>
</tr>
<tr>
<td valign="top">
				Sister Thea</td>
<td valign="top">
				A nun of the Order of Faith, Supra of the Convent of Saint Petra’s of Ellay on Castor</td>
</tr>
<tr>
<td valign="top">
				Malaki</td>
<td valign="top">
				Elder Shepherd in the Eliseer Estate Bond compound</td>
</tr>
</tbody>
</table>
<div>
<h2 class="chap" style="text-align: center;">
<span class="small">Society of the Phoenix</span></h2>
<table style="width: 100%">
<tbody>
<tr>
<td style="width: 35%;" valign="top">
					Dr. Andreas Riis</td>
<td valign="top">
					Founder of the Phoenix, chairman of its Council, and creator of the matter transmitter</td>
</tr>
<tr>
<td valign="top">
					Dr. Erica Radek</td>
<td valign="top">
					Council member, head of the Human Sciences Department</td>
</tr>
<tr>
<td valign="top">
					Ben Venturi</td>
<td valign="top">
					Council member and commander of Security and Intelligence</td>
</tr>
<tr>
<td valign="top">
					Predis Ussher</td>
<td valign="top">
					Council member, head of Communications, who claims to be the son of Elor, last Lord of the House of Peladeen</td>
</tr>
<tr>
<td valign="top">
					Emeric Garris</td>
<td valign="top">
					Council member, commander of Fleet Operations</td>
</tr>
<tr>
<td valign="top">
					John M’Kim</td>
<td valign="top">
					Council member, head of Supply and Maintenance</td>
</tr>
<tr>
<td valign="top">
					Manen Dyce</td>
<td valign="top">
					Council member, head of Computer Systems</td>
</tr>
<tr>
<td valign="top">
					Jan Barret</td>
<td valign="top">
					Leftant Commander in Fleet Operations</td>
</tr>
<tr>
<td valign="top">
					Valentin Severin</td>
<td valign="top">
					Assistant to Erica Radek</td>
</tr>
<tr>
<td valign="top">
					Jael</td>
<td valign="top">
					New member of the Phoenix, its first Outsider</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007character.vue?e258979a